// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { welcomeInitState } from './reducer';

const agreementPage = (state) => state.agreement || welcomeInitState;

const isCompAgreementLoading = createSelector(agreementPage, (cnter) => cnter.isCompAgreementLoading);
const compAgmnt = createSelector(agreementPage, (cnter) => cnter.compAgmnt);

export default {
	isCompAgreementLoading,
	compAgmnt,
};
